"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Icon = _interopRequireDefault(require("./Icon"));
var _theme = _interopRequireDefault(require("./styles/theme"));
var _lodash = require("lodash");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};
/* eslint-disable react-native/no-raw-text */
var Container = _styledComponents["default"].div.withConfig({
  displayName: "Container",
  componentId: "sc-38g556-0"
})(["display:grid;grid-template-columns:min-content auto min-content;align-items:center;justify-items:center;width:100%;max-width:550px;user-select:none;", ""], function (props) {
  return !props.showArrows && (0, _styledComponents.css)(["grid-template-columns:auto;"]);
});
var BoxContainer = _styledComponents["default"].div.withConfig({
  displayName: "BoxContainer",
  componentId: "sc-38g556-1"
})(["display:grid;grid-template-rows:45px auto;box-shadow:0 16px 32px rgba(47,56,62,0.13);min-width:276px;width:92%;margin:0 4px;"]);
var LabelContainer = _styledComponents["default"].div.withConfig({
  displayName: "LabelContainer",
  componentId: "sc-38g556-2"
})(["height:45px;background:", ";color:", ";font-family:Raleway;font-style:normal;font-weight:bold;line-height:22px;font-size:18px;padding:12px 26px"], _theme["default"].lightPrimary, _theme["default"].darkestGray);
var BodyContainer = _styledComponents["default"].div.withConfig({
  displayName: "BodyContainer",
  componentId: "sc-38g556-3"
})(["display:grid;grid-auto-rows:auto;grid-gap:16px;justify-items:center;align-items:center;background:white;padding:40px 16px;height:0;padding-bottom:30%;position:relative;"]);
var ComponentWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ComponentWrapper",
  componentId: "sc-38g556-4"
})(["position:absolute;display:grid;width:90%;justify-items:center;"]);
var BackIcon = _styledComponents["default"].div.withConfig({
  displayName: "BackIcon",
  componentId: "sc-38g556-5"
})(["cursor:pointer;&:active{opacity:0.7;}"]);
var NextIcon = _styledComponents["default"].div.withConfig({
  displayName: "NextIcon",
  componentId: "sc-38g556-6"
})(["cursor:pointer;&:active{opacity:0.7;}"]);
var PreviewBox = /*#__PURE__*/function (_Component) {
  _inherits(PreviewBox, _Component);
  var _super = _createSuper(PreviewBox);
  function PreviewBox(props) {
    var _this;
    _classCallCheck(this, PreviewBox);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "onNext", function () {
      var _this$state = _this.state,
        currentComponentIndex = _this$state.currentComponentIndex,
        componentNames = _this$state.componentNames;
      var onChange = _this.props.onChange;
      if (currentComponentIndex < componentNames.length - 1) {
        var newIndex = currentComponentIndex + 1;
        _this.setState({
          currentComponentIndex: newIndex
        });
        onChange(newIndex);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onBack", function () {
      var currentComponentIndex = _this.state.currentComponentIndex;
      var onChange = _this.props.onChange;
      if (currentComponentIndex > 0) {
        var newIndex = currentComponentIndex - 1;
        _this.setState({
          currentComponentIndex: newIndex
        });
        onChange(newIndex);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "getIconColors", function () {
      var _this$state2 = _this.state,
        currentComponentIndex = _this$state2.currentComponentIndex,
        componentNames = _this$state2.componentNames;
      var backIconColor = currentComponentIndex === 0 ? _theme["default"].disabled : _theme["default"].info;
      var nextIconColor = currentComponentIndex === componentNames.length - 1 ? _theme["default"].disabled : _theme["default"].info;
      return {
        backIconColor: backIconColor,
        nextIconColor: nextIconColor
      };
    });
    _this.state = {
      currentComponentIndex: 0,
      componentNames: null,
      components: null
    };
    return _this;
  }
  _createClass(PreviewBox, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      var children = this.props.children;
      if (children) {
        var componentNames = Object.keys(children);
        var components = Object.values(children);
        this.setState({
          componentNames: componentNames,
          components: components
        });
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var onChange = this.props.onChange;
      var children = nextProps.children;
      var componentNames = Object.keys(children);
      var components = Object.values(children);
      if (!(0, _lodash.isEqual)(this.state.componentNames, componentNames)) {
        this.setState({
          currentComponentIndex: 0
        });
        onChange(0);
      }
      this.setState({
        componentNames: componentNames,
        components: components
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state3 = this.state,
        currentComponentIndex = _this$state3.currentComponentIndex,
        componentNames = _this$state3.componentNames;
      var children = this.props.children;
      var _this$getIconColors = this.getIconColors(),
        backIconColor = _this$getIconColors.backIconColor,
        nextIconColor = _this$getIconColors.nextIconColor;
      var showArrows = componentNames && componentNames.length !== 1;
      return /*#__PURE__*/_react["default"].createElement(Container, {
        showArrows: showArrows
      }, showArrows && /*#__PURE__*/_react["default"].createElement(BackIcon, {
        onClick: this.onBack
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        color: backIconColor,
        iconName: "leftArrow",
        size: "2x"
      })), /*#__PURE__*/_react["default"].createElement(BoxContainer, null, /*#__PURE__*/_react["default"].createElement(LabelContainer, null, "Preview"), /*#__PURE__*/_react["default"].createElement(BodyContainer, null, /*#__PURE__*/_react["default"].createElement(ComponentWrapper, null, children[componentNames[currentComponentIndex]]))), showArrows && /*#__PURE__*/_react["default"].createElement(NextIcon, {
        onClick: this.onNext
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        color: nextIconColor,
        iconName: "rightArrow",
        size: "2x"
      })));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    value: // @ts-ignore
    function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);
  return PreviewBox;
}(_react.Component);
var _default = PreviewBox;
var _default2 = _default;
exports["default"] = _default2;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(Container, "Container", "/Users/crs/WebstormProjects/michelangelo/src/Components/PreviewBox.js");
  reactHotLoader.register(BoxContainer, "BoxContainer", "/Users/crs/WebstormProjects/michelangelo/src/Components/PreviewBox.js");
  reactHotLoader.register(LabelContainer, "LabelContainer", "/Users/crs/WebstormProjects/michelangelo/src/Components/PreviewBox.js");
  reactHotLoader.register(BodyContainer, "BodyContainer", "/Users/crs/WebstormProjects/michelangelo/src/Components/PreviewBox.js");
  reactHotLoader.register(ComponentWrapper, "ComponentWrapper", "/Users/crs/WebstormProjects/michelangelo/src/Components/PreviewBox.js");
  reactHotLoader.register(BackIcon, "BackIcon", "/Users/crs/WebstormProjects/michelangelo/src/Components/PreviewBox.js");
  reactHotLoader.register(NextIcon, "NextIcon", "/Users/crs/WebstormProjects/michelangelo/src/Components/PreviewBox.js");
  reactHotLoader.register(PreviewBox, "PreviewBox", "/Users/crs/WebstormProjects/michelangelo/src/Components/PreviewBox.js");
  reactHotLoader.register(_default, "default", "/Users/crs/WebstormProjects/michelangelo/src/Components/PreviewBox.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();